<template>
	<div class="home">
		<article class="head-box">
			<div class="head-txt flex zhong center"><img src="../image/top_texta.png" /></div>
		</article>
		<article class="history-center">
			<div class="firm-back flex zhong center" @click="homeTo()">
				<img src="../image/fh.png" />
				<span>返回</span>
			</div>
			<div class="history-list">
				<swiper :options="swiperOption" ref="mySwiper" style="height:100%;">
					<swiper-slide v-for="(item, index) in FzlcList" :key="index">
						<div class="history-ul flex">
							<div class="history-li" v-for="(item2, index2) in item.cidList" :key="index + '_' + index2">
								<div class="history-dd">
									<div class="history-txt">
										<p>{{ item2.content }}</p>
									</div>
								</div>
								<p class="history-time">{{ item2.year }}</p>
							</div>
						</div>
					</swiper-slide>

					<!-- <div class="swiper-button-prev" slot="button-prev"></div>
					<div class="swiper-button-next" slot="button-next"></div> -->
				</swiper>
			</div>
		</article>
	</div>
</template>
<script>
export default {
	data() {
		return {
			FzlcList: [],
			swiperOption: {
				loop: true,
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: false
				},
				// 显示分页
				pagination: {
					el: '.swiper-pagination',
					clickable: false
				}
				// 设置点击箭头
				// navigation: {
				// 	nextEl: '.swiper-button-next',
				// 	prevEl: '.swiper-button-prev'
				// }
			}
		};
	},
	computed: {
		swiper() {
			return this.$refs.mySwiper.swiper;
		}
	},
	mounted() {
		this.getFzlcList();
	},
	methods: {
		// 发展历程列表
		getFzlcList() {
			var that = this;
			that.$api.HtppRequest(
				'app/screen/getFzlcList',
				'GET',
				{},
				function(res) {
					if (res.code === 200) {
						that.FzlcList = [];
						var list = res.data;
						if (list && list.length > 0) {
							var cidList = [];
							list.map(a => {
								cidList.push(a);
								if (cidList.length >= 7) {
									that.FzlcList.push({
										cidList: cidList
									});
									cidList = [];
								}
							});
							if (cidList.length > 0) {
								that.FzlcList.push({
									cidList: cidList
								});
							}
							console.log('that.FzlcList', that.FzlcList);
						}
					}
				},
				function(err) {
					console.log('获取大屏信息错误', err);
				}
			);
		},
		// 首页
		homeTo() {
			this.$router.push('/home');
		}
	}
};
</script>
<style lang="scss" scoped>
.home {
	width: 100%;
	height: 100%;
}

.head-box {
	width: 100%;
	height: 86px;
	background: url('../image/top.png') no-repeat;
	background-size: 100% 100%;
}

.head-txt {
	width: 100%;
	height: 74px;
}

.head-txt img {
	width: 246px;
	height: 45px;
	margin: 0px auto;
}

// history-center
.history-center {
	width: 100%;
	height: calc(100% - 86px);
	padding: 0 20px 10px 20px;
	position: relative;
	margin-top: -15px;
}

.firm-back {
	width: 100px;
	height: 40px;
	background: rgba(14, 246, 255, 0.15);
	cursor: pointer;
}

.firm-back img {
	width: 20px;
	height: 14px;
	display: block;
	margin-right: 10px;
}

.firm-back span {
	font-size: 18px;
	color: #0ef6ff;
	font-weight: 600;
}

.history-list {
	width: 100%;
	height: calc(100% - 40px);
}

.history-ul {
	width: 100%;
	height: 100%;
	padding: 0 40px;
	position: relative;
	background: url('../image/falc_a.png') no-repeat center;
	background-size: 100% 248px;
}

.history-ul > img {
	width: 100%;
	height: 248px;
	display: block;
	position: absolute;
	left: 0;
	top: 50%;
	margin-top: -124px;
	z-index: 1;
}

.history-li {
	width: 294px;
	height: auto;
	position: absolute;
	margin-top: 115px;
	z-index: 2;
	top: 0;
}

.history-li:nth-child(2) {
	transform: rotate(-180deg);
	margin-left: 250px;
	margin-top: 410px;
}

.history-li:nth-child(2) .history-dd .history-txt {
	transform: rotate(180deg);
}

.history-li:nth-child(3) {
	margin-left: 490px;
	margin-top: 60px;
}

.history-li:nth-child(4) {
	transform: rotate(-180deg);
	margin-left: 755px;
	margin-top: 525px;
}

.history-li:nth-child(4) .history-dd .history-txt {
	transform: rotate(180deg);
}

.history-li:nth-child(5) {
	margin-left: 980px;
	margin-top: 120px;
}

.history-li:nth-child(6) {
	transform: rotate(-180deg);
	margin-left: 1250px;
	margin-top: 450px;
}

.history-li:nth-child(6) .history-dd .history-txt {
	transform: rotate(180deg);
}

.history-li:nth-child(7) {
	margin-left: 1465px;
	margin-top: 50px;
}

.history-dd {
	width: 294px;
	height: 338px;
	background: url('../image/falc_b.png') no-repeat;
	background-size: 100% 100%;
	margin-bottom: 15px;
}

.history-txt {
	width: 100%;
	height: 270px;
	padding: 30px 20px;
}

.history-txt p {
	text-align: center;
	font-size: 20px;
	color: #fff;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 7; //需要控制的文本行数
	overflow: hidden;
}

.history-time {
	width: 100px;
	height: 40px;
	text-align: center;
	font-size: 20px;
	color: #09d3e6;
	font-weight: bold;
	margin: 0 auto;
	line-height: 40px;
	background: linear-gradient(to right, rgba(9, 211, 230, 0.5), rgba(45, 102, 165, 0.5));
	transform: inherit;
}
</style>
